import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35e890d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark fixed-top bg-dark" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/logo.jpg",
  alt: "",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarCollapse",
  "aria-controls": "navbarCollapse",
  "aria-expanded": "false",
  "aria-label": ""
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarCollapse"
}
const _hoisted_6 = { class: "navbar-nav me-auto mb-2 mb-md-0" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Главная")
const _hoisted_9 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Пользователи")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Пароль")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Выход")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.account), 1)
          ]),
          _: 1
        }),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            (_ctx.subscriberType == 2)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/users"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/password"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_router_link, {
              to: "/exit",
              class: "nav-item nav-link"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}